// import Serializer from "./serializer";
import { title } from 'process';
import AxiosConfig from '../api/axios.config';
const Mustache = require('mustache');
import axios, { AxiosInstance } from 'axios';

let alertsBannerTemplate = require('../../templates/components/alerts/alert-banner_NEW').default;
let pageBannerTemplate = require('../../templates/components/alerts/alert-page-level-banner').default;
class SiteWideBanner {
    axiosClient: AxiosInstance;
    infoBanner: HTMLElement;

    constructor() {
        this.axiosClient = axios.create(AxiosConfig);
        this.init();
    }

    // has the date past
    public hasPast(date: string) {
        // get the current date
        const now = new Date();
        let dateParsed = new Date(date.replace(/-/g,"/")); 
        // compare the current date to the input date
        return now > dateParsed;
    }

    // handle actions when sitewide banner close button is clicked
    public bannerCloseHandler() {
        const bannerCloseButton = document.querySelector('#sitewide-banner .btn-close');
        bannerCloseButton.addEventListener('click', () => {
            const sitewideBanner = document.querySelector('.sitewide-banner') as HTMLDivElement;
            const mainContent: HTMLDivElement = document.querySelector('main.page-content');
            // set local storage to hide banner
            localStorage.setItem('sitewidebannerClosed', 'true');
            localStorage.setItem('sitewidebannerClosedDate', Date());

            // emit custom event on sitewide-banner close
            const bannerClosedEvent = new CustomEvent('closed', {
                detail: {},
                bubbles: true,
                cancelable: true
            });
            sitewideBanner.dispatchEvent(bannerClosedEvent);
        });
    }

    init() {
        const self = this;

        // attach sitewidebanner to the header
        const headerNav = document.querySelector('.header-nav');
        const secondaryNav = document.querySelector('.secondary-nav') as HTMLElement | null;
        const fixedMenuSpacer = document.querySelector('.fixed-menu-spacer') as HTMLElement | null;
        const sitewideBanner = document.createElement('div');
        sitewideBanner.classList.add('sitewide-banner');
        sitewideBanner.id = "sitewide-banner";
        headerNav.insertBefore(sitewideBanner, headerNav.firstChild);

        // check if the banner is active
        const isBannerHidden = localStorage.getItem('sitewidebannerClosed');
        if (isBannerHidden != null) {
            if(isBannerHidden === 'true')
            {
                let storedAlertTime = localStorage.getItem('sitewidebannerClosedDate');
                const currentDate = new Date();
                const alertTime : Date = new Date(storedAlertTime);
                let aWeekLater : Date = new Date();
                aWeekLater.setDate(alertTime.getDate() + 5);
                
                if(storedAlertTime != null)
                {
                    //has it been over a week?
                    if(currentDate.getTime() > aWeekLater.getTime()){
                        // reset banner
                        localStorage.removeItem('sitewidebannerClosed');
                        localStorage.removeItem('sitewidebannerClosedDate');
                    } else {
                        // just keep alert hidden
                        sitewideBanner.style.display = 'none';
                    }
                }
            }
        }
        
        // TODO: change link to prod domain - make a global config for axios
        this.axiosClient.get(`api/alerts/banner`)
        .then(function (response) {
            let alertBannerTemplateRendered = "";
            
            if (response.data) {
                let data = response.data;
                if (data) {
                    if (data.alerts) {
                        // let header = document.querySelector(".header-nav");
                        let globalAlert = data.alerts.globalAlert;
                        let siteAlerts = data.alerts.siteAlerts;
                        let renderTopAlertFn = function(alert) {
                            alertBannerTemplateRendered = Mustache.render(alertsBannerTemplate, alert);
                            let sitewideBanner = document.querySelector(".sitewide-banner");
                            let secondaryNavHeight: number; 
                            let sitewideBannerHeight: number;
                            let spacerHeight: number;

                            // TEMP FIX for OH: Only show on homepage and /continuing-education
                            let currentPath = window.location.pathname;

                            if (sitewideBanner) {
                                let doc = new DOMParser().parseFromString(alertBannerTemplateRendered, "text/html");

                                let alertDOM = doc.querySelector('div');
                                
                                sitewideBanner.insertBefore(alertDOM, sitewideBanner.firstChild);

                                // add close event listener
                                self.bannerCloseHandler();

                                // adjust spacer height if alert banner exists
                                secondaryNavHeight = secondaryNav ? secondaryNav.clientHeight : 0;
                                sitewideBannerHeight = sitewideBanner ? sitewideBanner.clientHeight : 0;
                                spacerHeight = sitewideBannerHeight + secondaryNavHeight;
                                if(fixedMenuSpacer) {
                                    fixedMenuSpacer.style.height = spacerHeight + 'px';
                                }
                            }
                        };
                        if (globalAlert.active == "yes") {
                            // scheduler
                            let startEnabled = false;
                            let endEnabled = false;
                            if (globalAlert.scheduler.startEnabled == "yes")
                            {
                                startEnabled = true;
                            }
                            if (globalAlert.scheduler.endEnabled == "yes")
                            {
                                endEnabled = true;
                            }

                            // render alert function
                            // let renderAlertFn = function() {
                            //     alertBannerTemplateRendered = Mustache.render(alertsBannerTemplate, globalAlert);
                            //     let sitewideBanner = document.querySelector(".sitewide-banner");
                            //     let secondaryNavHeight: number; 
                            //     let sitewideBannerHeight: number;
                            //     let spacerHeight: number;

                            //     // TEMP FIX for OH: Only show on homepage and /continuing-education
                            //     let currentPath = window.location.pathname;

                            //     if (sitewideBanner) {
                            //         let doc = new DOMParser().parseFromString(alertBannerTemplateRendered, "text/html");

                            //         let alertDOM = doc.querySelector('div');
                                    
                            //         sitewideBanner.insertBefore(alertDOM, sitewideBanner.firstChild);

                            //         // add close event listener
                            //         self.bannerCloseHandler();

                            //         // adjust spacer height if alert banner exists
                            //         secondaryNavHeight = secondaryNav ? secondaryNav.clientHeight : 0;
                            //         sitewideBannerHeight = sitewideBanner ? sitewideBanner.clientHeight : 0;
                            //         spacerHeight = sitewideBannerHeight + secondaryNavHeight;
                            //         if(fixedMenuSpacer) {
                            //             fixedMenuSpacer.style.height = spacerHeight + 'px';
                            //         }
                            //     }
                            // };

                            if (startEnabled && endEnabled) {
                                // just check start time
                                if (self.hasPast(globalAlert.scheduler.startDatetime) && !self.hasPast(globalAlert.scheduler.endDatetime)) {
                                    // render the alert
                                    renderTopAlertFn(globalAlert);
                                }
                            } else if (startEnabled && !endEnabled) {
                                // just check start time
                                if (self.hasPast(globalAlert.scheduler.startDatetime)) {
                                    // render the alert
                                    renderTopAlertFn(globalAlert);
                                }
                            } else if (!startEnabled && endEnabled) {
                                // just check end time
                                if (!self.hasPast(globalAlert.scheduler.endDatetime)) {
                                    // render the alert
                                    renderTopAlertFn(globalAlert);
                                }
                            }
                            return
                        }

                        // for non global alerts
                        if(siteAlerts)
                        {
                            let alertPageBannerTemplateRendered = "";
                            let pageHeader = document.querySelector("main.page-content");

                            let renderSiteAlertsFn = function(alert: any){
                                let currentUrl = window.location.href.split('?')[0];
                                alertPageBannerTemplateRendered = Mustache.render(pageBannerTemplate, alert);

                                    let urlPath = new URL(alert.siteUrl.replace("/index", "")).pathname;
                                    let currUrlPath = new URL(currentUrl).pathname;
                                    console.log('Comparing alert url path and current url path:', urlPath, currUrlPath);
                                        if(currUrlPath == urlPath){
                                            renderTopAlertFn({
                                                cta: alert.cta,
                                                scheduler: alert.scheduler,
                                                title: alert.title,
                                                summary: alert.content,
                                                theme: alert.theme,
                                                isWarning: alert.theme === 'alert' ? true : false,
                                                isInfo: alert.theme === 'info' ? true : false,
                                                isEmergency: false,
                                            })
                                            // let doc = new DOMParser().parseFromString(alertPageBannerTemplateRendered, "text/html");
                                            // let alertDOM = doc.querySelector('div');
                                            // pageHeader.insertBefore(alertDOM, pageHeader.firstChild);
                                        } else {
                                            if(alert.children == "yes")
                                            {
                                                if(currentUrl.includes(urlPath)){
                                                    renderTopAlertFn({
                                                        cta: alert.cta,
                                                        scheduler: alert.scheduler,
                                                        title: alert.title,
                                                        summary: alert.content,
                                                        theme: alert.theme,
                                                        isWarning: alert.theme === 'warning' ? true : false,
                                                        isInfo: alert.theme === 'info' ? true : false,
                                                        isEmergency: false,
                                                    })
                                                    // let doc = new DOMParser().parseFromString(alertPageBannerTemplateRendered, "text/html");
                                                    // let alertDOM = doc.querySelector('div');
                                                    // pageHeader.insertBefore(alertDOM, pageHeader.firstChild);
                                                }
                                            }
                                        }
                            }

                            siteAlerts.forEach(alert => {
                                let startEnabled = false;
                                let endEnabled = false;
                                if (alert.scheduler.startEnabled == "yes")
                                {
                                    startEnabled = true;
                                }
                                if (alert.scheduler.endEnabled == "yes")
                                {
                                    endEnabled = true;
                                }
                                if(alert.siteUrl)
                                {
                                    if (startEnabled && endEnabled) {
                                        // just check start time
                                        if (self.hasPast(alert.scheduler.startDatetime) && !self.hasPast(alert.scheduler.endDatetime)) {
                                            // render the alert
                                            renderSiteAlertsFn(alert);
                                        }
                                    } else if (startEnabled && !endEnabled) {
                                        // just check start time
                                        if (self.hasPast(alert.scheduler.startDatetime)) {
                                            // render the alert
                                            renderSiteAlertsFn(alert);
                                        }
                                    } else if (!startEnabled && endEnabled) {
                                        // just check end time
                                        if (!self.hasPast(alert.scheduler.endDatetime)) {
                                            // render the alert
                                            renderSiteAlertsFn(alert);
                                        }
                                    }
                                }
                            });
                        }
                    }
                }
            }
        })
        .catch(function (error) {
            // log an error to the console to debug / allow people to see it for feedback help
            console.log("SAIT APP - ERROR: ", error);
        });
    }
}

export default SiteWideBanner;